import {TitleStyled} from "@/components/UI/Title/Title.styled";


const titleTypes = {
    xl: 'h1',
    lg: 'h2',
    md: 'h3',
    sm: 'h4',
    xs: 'h5',
    'md:subtitle': 'h3',
    'sm:subtitle': 'h4'
}

const Title = ({children, color, size, ...props}) => {
    const as = titleTypes[size] ?? titleTypes.xs

    return (
        <TitleStyled as={as} {...props} color={color} size={size}>{children}</TitleStyled>
    );
};

export default Title;